<template>
  <div class="my-card">
    <b-button
      v-b-toggle.sidebar-invoice-add-new-customer
      variant="primary"
      class="add-new-client-header mr-1"
    >
      Tambah Pelanggan
    </b-button>
    <b-button
      variant="outline-warning"
      class="mr-1"
      :to="{name: 'master-customer-bill'}"
    >
      <feather-icon
        icon="UsersIcon"
        class="mr-50"
      />
      Tagihan Pelanggan
    </b-button>
    <b-button
      variant="outline-success"
      class="mr-1"
      :to="{name: 'master-customer-deposit'}"
    >
      <feather-icon
        icon="PocketIcon"
        class="mr-50"
      />
      Deposit Pelanggan
    </b-button>
    <!-- search input -->
    <div class="custom-search d-flex justify-content-end">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Search</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Search"
            type="text"
            class="d-inline-block"
          />
        </div>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :total-rows="totalRows"
      mode="remote"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
      @on-search="onSearch"
      @on-page-change="onPageChange"
      @on-per-page-change="onPerPageChange"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle mr-25"
                />
              </template>
              <b-dropdown-item :to="{ name: 'master-customer-edit', params: { id: props.row.id } }">
                <feather-icon
                  icon="Edit2Icon"
                  class="mr-50"
                />
                <span>Edit</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-b-modal.modal-history-deposit
                @click="openDepoModal(props.row['id'], props.row['depo_balance'])"
              >
                <feather-icon
                  icon="ClockIcon"
                  class="mr-50"
                />
                <span>Riwayat Deposit</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <!-- sidebar -->
    <b-sidebar
      id="sidebar-invoice-add-new-customer"
      title="Tambah Pelanggan"
      backdrop
      right
      shadow
    >
      <invoice-sidebar-add-new-customer
        :customer="customer"
        @submitCustomer="handleCustomerSubmit"
      />
    </b-sidebar>

    <!-- modal presales -->
    <b-modal
      id="modal-history-deposit"
      class="print-area"
      ok-only
      ok-title="Tutup"
      centered
      size="lg"
      title="Riwayat Deposit Pelanggan"
    >
      <b-card-body>
        <div class="mt-2">
          <b-form-group label="Saldo Deposit">
            <b-form-input
              type="text"
              class="form-control text-right"
              :value="`${new Intl.NumberFormat('en-US').format(depositBalance)}`"
              readonly
            />
          </b-form-group>
        </div>
        <div class="mt-2">
          <b-table-lite
            responsive
            :items="depositHistory"
            :fields="[
              { key: 'date', label: 'Tanggal Transaksi' },
              { key: 'in_out', label: 'In/Out' },
              { key: 'nominal', label: 'Nominal' },
              { key: 'source', label: 'Kas' },
            ]"
          />

          <!-- Pagination Controls -->
          <b-pagination
            v-model="depositHistoryTable.currentPage"
            class="no-print"
            :per-page="depositHistoryTable.perPage"
            :total-rows="depositHistoryTable.totalRows"
            align="center"
            @input="getDepositData"
          />

        </div>

        <button
          class="btn btn-info mt-2"
          @click="printHistory()"
        >
          Print
        </button>
      </b-card-body>
    </b-modal>
  </div>
</template>

<script>
import {
  BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, VBToggle, BDropdownItem,
  BButton, BTableLite,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import Ripple from 'vue-ripple-directive'
import InvoiceSidebarAddNewCustomer from '../InvoiceSidebarAddNewCustomer.vue'

export default {
  components: {
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BTableLite,
    BDropdownItem,
    BButton,
    InvoiceSidebarAddNewCustomer,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,

  },
  data() {
    return {
      pageLength: 10,
      dir: false,
      columns: [
        { field: 'name', label: 'Nama Pelanggan' },
        { field: 'phone', label: 'No Hp' },
        { field: 'action', label: 'Action' },
      ],
      rows: [],
      totalRows: 0,
      serverParams: {
        page: 1,
        perPage: 10,
        search: '',
      },
      searchTerm: '',
      customer: {
        name: '',
        email: '',
        address: '',
        country: '',
        contact: '',
      },
      showDepoModal: false,
      depositHistory: [],
      depositBalance: 0,
      activeID: '',
      depositHistoryTable: {
        currentPage: 1,
        perPage: 5,
        totalRows: 0,
      },
    }
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true
        return this.dir
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false
      return this.dir
    },
  },
  created() {},
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$http.get('/customer', {
        params: {
          page: this.serverParams.page,
          per_page: this.serverParams.perPage,
          q: this.serverParams.search,
        },
      })
        .then(res => {
          this.rows = res.data.data.data.map(cus => ({
            id: cus.id,
            name: cus.name,
            phone: cus.phone,
            depo_balance: cus.depo_balance,
          }))

          this.totalRows = res.data.data.total
        })
    },
    onSearch(search) {
      if (search.searchTerm === '') {
        this.serverParams.search = ''
        this.serverParams.page = 1 // reset ke halaman 1
        this.loadData()
        return
      }
      if (search.searchTerm.length < 3) return

      this.serverParams.search = search.searchTerm
      this.serverParams.page = 1 // reset ke halaman 1
      this.loadData()
    },
    onPageChange(params) {
      this.serverParams.page = params.currentPage
      this.loadData()
    },
    onPerPageChange(params) {
      this.serverParams.perPage = params.currentPerPage
      this.loadData()
    },
    handleCustomerSubmit(customer) {
      this.$http.post('/customer/add', customer)
        .then(() => {
          this.$bvToast.toast('Data Customer Berhasil Ditambah!', {
            title: 'Success',
            variant: 'success',
            solid: true,
          })
          this.$http.get('/customer')
            .then(res => {
              this.rows = res.data.data.map(cus => ({
                id: cus.id,
                name: cus.name,
                phone: cus.phone,
              }))
            })
        })
        .catch(err => {
          let message = 'Gagal menambahkan Customer.'

          if (err.response) {
            // Cek jika ada response dari server
            if (err.response.status === 422 && err.response.data.errors) {
              // Menangani error validasi (422 Unprocessable Entity)
              const { errors } = err.response.data
              // Gabungkan semua pesan error menjadi satu string
              message = Object.values(errors).flat().join(' ')
            } else if (err.response.data && err.response.data.message) {
              // Menangani error lainnya dengan pesan dari Laravel
              message = err.response.data.message
            }
          }

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })

          console.error(err)
        })
    },
    openDepoModal(id, balance) {
      this.showDepoModal = true
      this.depositBalance = balance
      this.getDepositData(id)
      this.activeID = id
    },
    getDepositData(id) {
      this.$http.get(`depo-history/getByCustomer/${id}`, {
        params: {
          page: this.depositHistoryTable.currentPage,
          per_page: this.depositHistoryTable.perPage,
        },
      })
        .then(res => {
          console.log(res.data.data)
          this.depositHistory = res.data.data.map(dh => ({
            nominal: new Intl.NumberFormat('en-US').format(dh.nominal),
            in_out: dh.in_out === 1 ? 'In' : 'Out',
            source: dh.cash.name,
            date: new Date(dh.created_at).toLocaleString('id-ID', { timeZone: 'Asia/Jakarta' }),
          }))

          this.depositHistoryTable.totalRows = res.data.total
        })
    },
    printHistory() {
      if (!this.activeID) {
        console.error('activeID belum ada')
        return
      }
      const route = this.$router.resolve({
        name: 'print-customer-deposit',
        params: { id: this.activeID },
      })

      window.open(route.href, '_blank')
    },
  },
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
